import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HeartPulse, ChevronRight } from 'lucide-react';
import api from '@/lib/api';

export default function MyRecoveryCard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get('/patient/recovery/mine').then(({ data }) => setRows(data.rows || [])).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <div className="mb-6 rounded-2xl bg-white border border-teal-200 p-4" data-testid="my-recovery-card">
      <div className="text-[12px] font-bold uppercase tracking-wider text-teal-700 flex items-center gap-1.5"><HeartPulse size={14} /> My recovery plans & discharge prescriptions</div>
      <ul className="mt-2 divide-y divide-slate-100">
        {rows.map((r) => (
          <li key={r.id}>
            <Link to={`/recovery/${r.id}`} className="py-2.5 flex items-center gap-2 text-[14px]" data-testid={`my-recovery-link-${r.id}`}>
              <span className="flex-1 font-semibold text-slate-800">{r.operation}<span className="block text-[12px] font-normal text-slate-500">{r.hospital_name}</span></span>
              <span className={`text-[11px] font-bold ${r.status === 'published' ? 'text-emerald-700' : 'text-slate-400'}`}>{r.status === 'published' ? 'Active' : 'Completed'}</span>
              <ChevronRight size={16} className="text-slate-400" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
